<script>
export const pageName = 'map-printable';
export const pageRoute = '/model-achievement-programme/printable';
export const title = 'Model Achievement Programme'
export const requireAuth = false

import { listenToMapScoreboard } from '../../js/readModel.js';
import { getUserMap } from '../../js/utils/map.js';

export default {
	data() {
		return {
			currentUser: null,
			data: null,
			scoreboard: null,
			backgrounds: {},
			ready: false
		}
	},

	methods: {
		async boot(opts) {
			this.data = await getUserMap(null);
			this.ready = true;
			
			const mql = matchMedia('print');
			mql.addListener(m => {
				if (!m.matches)
					return;

				document.$('.pageRef').forEach(a => {
					let target = document.$1(a.dataset.target)
					
					// 1460 is a complete guess based on page height in print mode, it seems right with 50px margins, on chrome on my desktop. Fuck me what a hack
					const page = Math.floor(target.getBoundingClientRect().top / 1460) + 1
					a.innerText = 'Page ' + page;
				})
			});
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<h1 class="display-4 text-center mb-3">Model Achievement Programme</h1>
		<p class="text-muted text-center mb-3">The Model Achievement Programme is a fantastic opportunity to develop your skills as a rocket modeller by completing a series of increasingly difficult and complicated challenges.</p>

		<div class="text-center break" v-for="(subject, i) in data.subjects">
			<p class="mb-3 display-4">Subjects</p>
			<h1 class="mb-4 display-2">{{ subject.name }}</h1>
			<div class="row">
				<div v-for="task in subject.tasks" class="col-3">
					<div class="card card-fill card-fill-top">
						<div class="card-body">
							<div class="d-inline-block" :style="`background: url(${task.bg}); ${task.mode == 'future' ? 'opacity: 0.5' : ''}`">
								<img :src="task.icon" />
							</div>
							<h2 :class="`${task.mode == 'future' ? 'text-muted' : 'text-body'}`">{{ task.name }}</h2>
							<p>{{ task.desc }}</p>
							<div :data-target="`#${task.id.replace('.', '_').replace('/', '_')}`" class="pageRef">Page</div>
							<span v-if="task.xp !== undefined && !task.complete" :class="`badge ${task.special ? 'badge-primary' : 'badge-white text-primary'} border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.xp }} XP{{ task.special ? ' ' + task.special : null }}</span>
							<span v-if="task.xp !== undefined && task.complete" :class="`badge badge-success border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">Complete</span>
							<span v-if="task.hydrazine" :class="`badge ${task.special ? 'badge-danger' : 'badge-white text-danger'} shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.hydrazine }} Hydrazine{{ task.special ? ' ' + task.special : null }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center break">
			<p class="mb-3 display-4">Extras</p>
			<h1 class="mb-4 display-2">Bonuses</h1>
			<p class="text-muted mb-5">Unlock these tasks by earning Hydrazine.</p>
			<div class="row">
				<div v-for="task in data.bonuses" class="col-3">
					<div class="card card-fill card-fill-top">
						<div class="card-body">
							<div class="d-inline-block" :style="`background: url(${task.bg});}`">
								<img :src="task.icon" />
							</div>
							<h2 class="text-body">{{ task.name }}</h2>
							<p class="text-muted">{{ task.desc }}</p>
							<div :data-target="`#${task.id.replace('.', '_').replace('/', '_')}`" class="pageRef">Page</div>
							<span v-if="task.xp && !task.complete" :class="`badge badge-white border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.xp }} XP</span>
							<span v-if="task.xp && task.complete" :class="`badge badge-success border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">Complete</span>
							<span v-if="task.hydrazine" :class="`badge badge-soft-danger shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.hydrazine }} Hydrazine</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center break" v-for="(level, i) in data.levels">
			<p class="mb-3 display-4">Ranks</p>
			<h1 class="mb-4 display-2">{{ level.name }}</h1>
			<p v-if="level.xpRequired" class="text-muted mb-5">You need {{ level.xpRequired }} XP to graduate from this rank.</p>
			<p v-else class="text-muted mb-5">This is the highest rank within MAP.</p>
			<div class="row">
				<template v-for="subject of data.levels[i].subjects">
					<template v-if="subject.tasks.length">
						<div v-for="task in subject.tasks" class="col-3">
							<div class="card card-fill card-fill-top">
								<div class="card-body">
									<div class="d-inline-block" :style="`background: url(${task.bg}); ${task.mode == 'future' ? 'opacity: 0.5' : ''}`">
										<img :src="task.icon" />
									</div>
									<h2 :class="`${task.mode == 'future' ? 'text-muted' : 'text-body'}`">{{ task.name }}</h2>
									<p>{{ task.desc }}</p>
									<div :data-target="`#${task.id.replace('.', '_').replace('/', '_')}`" class="pageRef">Page</div>
									<span v-if="task.xp !== undefined && !task.complete" :class="`badge ${task.special ? 'badge-primary' : 'badge-white text-primary'} border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.xp }} XP{{ task.special ? ' ' + task.special : null }}</span>
									<span v-if="task.xp !== undefined && task.complete" :class="`badge badge-success border border-1 shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">Complete</span>
									<span v-if="task.hydrazine" :class="`badge ${task.special ? 'badge-danger' : 'badge-white text-danger'} shadow font-weight-bold`" style="position: absolute; top: -5px; right: -5px; font-size: 90%">+{{ task.hydrazine }} Hydrazine{{ task.special ? ' ' + task.special : null }}</span>
								</div>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>
		<template v-for="(subject, i) in data.subjects">
			<template v-for="task in subject.tasks">
				<div :id="task.id.replace('.', '_').replace('/', '_')" class="break">
					
					<div class="row align-items-center">
						<div class="col-3">
							<div class="d-inline-block" :style="`background: url(${task.bg});}`">
								<img :src="task.icon" />
							</div>
						</div>
						<div class="col-6">
							<p class="text-center mb-3 display-4">Tasks</p>
							<h1 class="text-center mb-4 display-2">{{ task.name }}</h1>
						</div>
						<div class="col-3"></div>
					</div>

					<p>{{task.fullDesc || task.desc}}</p>
					<p>This task is worth {{task.xp ? `${task.xp} XP` : `${task.hydrazine} Hydrazine`}}.</p>
										
					<div v-if="task.specialFull" class="alert alert-primary mb-4">
						<p class="mb-0"><span class="fe fe-info"></span> {{ task.specialFull }}</p>
					</div>
					
					<div v-if="task.disambiguation" class="alert alert-light mb-4">
						<p class="mb-0"><span class="fe fe-info"></span> {{ task.disambiguation }}</p>
					</div>
					
					<h4 class="display-4">Pass criteria</h4>
					<ul class="mb-5">
						<li v-for="rule in task.rules.pass" class="mb-2">{{ rule }}</li>
						<li class="mb-2">The rocket must be inspected by the RSO on duty prior to launch and meet the safety and stability requirements</li>
						<li>The flight must be successful and the rocket recovered in a state ready to fly again without major repairs</li>
					</ul>

					<template v-if="task.rules.options && task.rules.options.length">
						<h4 class="display-4">Options</h4>
						<ul class="mb-5">
							<li v-for="rule in task.rules.options" class="mb-2">{{ rule }}</li>
						</ul>
					</template>
					
					<h4 class="display-4">Fail conditions</h4>
					<ul>
						<li v-for="rule in task.rules.fail" class="mb-2">{{ rule }}</li>
						<li class="mb-2">The rocket is not built or flown in accordance with the UKRA Safety Code</li>
						<li class="mb-2">The flight is severely unstable or unsafe in any way</li>
						<li class="mb-2">The rocket is recovered in a damaged state such that it cannot fly again without non-trivial repairs</li>
						<li class="mb-2">All parts of the rocket are not recovered (except for exceptional circumstances, like landing in a tree)</li>
						<li>The MAP Assessor does not believe the flyer performed the task themselves. Exceptions are made for young flyers or those with disabilities who need assistance. In these cases, assistants should operate under the flyer's instruction.</li>
					</ul>
				</div>
			</template>
		</template>
    </div>
</template>
